module.exports = __webpack_public_path__ + "static/media/T.47daca61.png";